(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-story"] && !Shopify.designMode) return;
  try {
    
  // Founder click-to-play: swap the studio poster for Aja's video in place.
  document.querySelectorAll('[data-founder-media]').forEach(function (media) {
    var trigger = media.querySelector('[data-founder-play]');
    var video = media.querySelector('.about-founder__video-el');
    if (!trigger || !video) return;
    trigger.addEventListener('click', function () {
      trigger.hidden = true;
      video.hidden = false;
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        // If autoplay-on-click is blocked, controls are visible so the user can start it.
        playPromise.catch(function () {});
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  // Section JS is bundled into one deferred asset, so document.currentScript
  // can't reach back into the section's DOM — select tracks globally instead
  // (same pattern as the reels carousel).
  document.querySelectorAll('.announce__track[data-rotate="true"]').forEach(function (track) {
    var items = track.querySelectorAll('.announce__msg');
    if (items.length < 2) return;
    var i = 0;
    var interval = parseInt(track.dataset.interval, 10) || 5000;
    setInterval(function () {
      items[i].classList.remove('is-current');
      i = (i + 1) % items.length;
      items[i].classList.add('is-current');
    }, interval);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  /*
    Cart page client behavior:
      - +/- buttons and input change call /cart/change.js with the line index,
        update the subtotal + free-ship bar, and re-render the row's line price.
      - Remove links are intercepted to be AJAX (no full reload) and refresh
        the cart page section in place using Shopify's Section Rendering API.
      - On any quantity hitting 0, the row is removed without a full reload.
      - Fall back to full form submit if JS errors so customers don't get stuck.
   */
  (function () {
    const section = document.querySelector('[data-cart-page]');
    if (!section) return;

    // SHIPPING_THRESHOLD_CENTS not needed client-side — the free-ship bar is
    // re-rendered server-side via the cart section endpoint on every change.

    const money = (cents) => {
      // Quick client-side formatter — Shopify-style $X.XX. For non-USD shops
      // this should use a stored money_format, but for TA we're USD-only.
      const dollars = (cents / 100).toFixed(2);
      return '$' + dollars;
    };

    async function refreshSection() {
      try {
        const res = await fetch(window.location.pathname + '?sections=cart');
        const data = await res.json();
        const html = data['cart'];
        if (!html) return false;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-cart-page]');
        if (!fresh) return false;
        section.replaceWith(fresh);
        return true;
      } catch (e) {
        return false;
      }
    }

    async function changeLine(lineIndex, quantity) {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: lineIndex, quantity: quantity, sections: 'cart-drawer' })
      });
      if (!res.ok) throw new Error('Cart change failed');
      const cart = await res.json();
      // Also update drawer if present on this page (it is — rendered in layout)
      if (cart.sections && cart.sections['cart-drawer']) {
        const parser = new DOMParser();
        const newDrawerDoc = parser.parseFromString(cart.sections['cart-drawer'], 'text/html');
        const freshDrawer = newDrawerDoc.querySelector('#cart-drawer');
        const existingDrawer = document.querySelector('#cart-drawer');
        if (freshDrawer && existingDrawer) {
          existingDrawer.innerHTML = freshDrawer.innerHTML;
        }
      }
      // Update header cart count
      const cartBtn = document.querySelector('.header__cart-btn');
      if (cartBtn) {
        let badge = cartBtn.querySelector('.header__cart-count');
        if (cart.item_count > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'header__cart-count';
            cartBtn.appendChild(badge);
          }
          badge.textContent = cart.item_count;
        } else if (badge) {
          badge.remove();
        }
      }
      return cart;
    }

    section.addEventListener('click', async (e) => {
      // Remove link → AJAX
      const removeLink = e.target.closest('[data-cart-remove]');
      if (removeLink) {
        e.preventDefault();
        const row = removeLink.closest('[data-cart-line]');
        if (!row) return;
        const lineIndex = Number(row.dataset.cartLine);
        try {
          await changeLine(lineIndex, 0);
          await refreshSection();
        } catch (err) {
          window.location.href = removeLink.href;
        }
        return;
      }

      // Quantity buttons
      const down = e.target.closest('[data-qty-down]');
      const up = e.target.closest('[data-qty-up]');
      if (down || up) {
        const input = (down || up).parentElement.querySelector('[data-qty-input]');
        if (!input) return;
        const current = Number(input.value) || 0;
        const next = Math.max(0, current + (up ? 1 : -1));
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    section.addEventListener('change', async (e) => {
      const input = e.target.closest('[data-qty-input]');
      if (!input) return;
      const lineIndex = Number(input.dataset.lineIndex);
      const quantity = Math.max(0, Number(input.value) || 0);

      try {
        await changeLine(lineIndex, quantity);
        // Re-render the cart page section so prices, line counts, free-ship bar,
        // and empty-state all reflect the new cart in one pass.
        await refreshSection();
      } catch (err) {
        // Soft fallback — restore prev value visually
        input.value = input.defaultValue;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(){
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      document.querySelectorAll('[data-act-cycle]').forEach(function(media){
        if (media.dataset.actInit) return;
        var slides = media.querySelectorAll('.activity-slide');
        if (slides.length < 2) return;
        media.dataset.actInit = '1';
        var interval = parseInt(media.dataset.interval, 10) || 5000;
        var offset = parseInt(media.dataset.offset, 10) || 0;
        var i = 0;
        // Staggered start so the tiles don't all cross-fade in lockstep.
        setTimeout(function(){
          setInterval(function(){
            slides[i].classList.remove('is-current');
            i = (i + 1) % slides.length;
            slides[i].classList.add('is-current');
          }, interval);
        }, offset);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["founder-story"] && !Shopify.designMode) return;
  try {
    
  // Founder click-to-play: swap the studio poster for Aja's video in place.
  // Both the poster and the pull-quote cue drive the same player.
  document.querySelectorAll('[data-founder-root]').forEach(function (root) {
    var media = root.querySelector('[data-founder-media]');
    if (!media) return;
    var trigger = media.querySelector('[data-founder-play]');
    var video = media.querySelector('.founder__video-el');
    if (!trigger || !video) return;

    function play() {
      trigger.hidden = true;
      video.hidden = false;
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }

    trigger.addEventListener('click', function () {
      play();
    });

    var cue = root.querySelector('[data-founder-cue]');
    if (cue) {
      cue.addEventListener('click', function () {
        play();
        // Only pull the player into view when it isn't already there (mobile,
        // where the frame sits above the copy and may be scrolled past).
        var rect = video.getBoundingClientRect();
        var offscreen = rect.top < 0 || rect.bottom > window.innerHeight;
        if (offscreen && typeof video.scrollIntoView === 'function') {
          video.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["founder-video-hero"] && !Shopify.designMode) return;
  try {
    
  // Founder hero click-to-play: swap the poster for the video and play with sound.
  document.querySelectorAll('.founder-hero[data-founder-media]').forEach(function (media) {
    var trigger = media.querySelector('[data-founder-play]');
    var video = media.querySelector('.founder-hero__video');
    var overlay = media.querySelector('[data-founder-overlay]');
    if (!trigger || !video) return;
    trigger.addEventListener('click', function () {
      trigger.hidden = true;
      if (overlay) overlay.hidden = true;
      video.hidden = false;
      var p = video.play();
      if (p && typeof p.catch === 'function') { p.catch(function () {}); }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    const modal = document.getElementById('search-modal');
    if (!modal) return;
    const input = modal.querySelector('[data-search-input]');
    const results = modal.querySelector('[data-search-results]');

    function open() {
      modal.inert = false;
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      setTimeout(() => input?.focus(), 50);
    }
    function close() {
      modal.setAttribute('aria-hidden', 'true');
      modal.inert = true;
      document.documentElement.style.overflow = '';
      input.value = '';
      results.innerHTML = '';
    }

    document.querySelectorAll('[data-open-search]').forEach(el => el.addEventListener('click', open));
    document.querySelectorAll('[data-close-search]').forEach(el => el.addEventListener('click', close));
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') close(); });

    let debounceTimer;
    let lastQuery = '';
    input?.addEventListener('input', () => {
      clearTimeout(debounceTimer);
      const q = input.value.trim();
      if (!q || q.length < 2) { results.innerHTML = ''; lastQuery = ''; return; }
      if (q === lastQuery) return;
      debounceTimer = setTimeout(() => fetchSuggestions(q), 200);
    });

    async function fetchSuggestions(q) {
      lastQuery = q;
      try {
        const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last`;
        const res = await fetch(url, { headers: { 'Accept': 'application/json' } });
        if (!res.ok) throw new Error(res.status);
        const data = await res.json();
        if (q !== lastQuery) return;  // stale response
        renderResults(data.resources?.results?.products || []);
      } catch (err) {
        results.innerHTML = '<p class="empty">Search is having a moment — hit Enter to try the full search page instead.</p>';
      }
    }

    function renderResults(products) {
      if (!products.length) {
        results.innerHTML = '<p class="empty">No matches. Try a different word or hit Enter for the full search.</p>';
        return;
      }
      results.innerHTML = products.map(p => {
        const img = p.featured_image?.url || p.image || '';
        const price = p.price ? formatMoney(p.price) : '';
        return `
          <a class="pr-card" href="${p.url}">
            <div class="img">${img ? `<img src="${img}" alt="" loading="lazy">` : ''}</div>
            <span class="name">${escape(p.title || '')}</span>
            <span class="price">${price}</span>
          </a>
        `;
      }).join('');
    }

    function formatMoney(cents) {
      const dollars = (parseFloat(cents) / 100).toFixed(2);
      return '$' + dollars;
    }
    function escape(s) {
      return String(s ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lifestyle-band"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(){
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      document.querySelectorAll('[data-lband-slides]').forEach(function(wrap){
        if (wrap.dataset.lbandInit) return;
        var slides = wrap.querySelectorAll('.lband__slide');
        if (slides.length < 2) return;
        wrap.dataset.lbandInit = '1';
        var interval = parseInt(wrap.dataset.interval, 10) || 5000;
        var FADE = 900; // must match the .is-current transition duration
        var i = 0;
        var timer = null;

        // Slides 2+ are lazy-loaded, so the first swap could land on an image
        // that hasn't decoded yet — a genuinely blank frame rather than just a
        // dip. Decode before swapping; if decode is unsupported or rejects
        // (e.g. the image 404s) fall through and swap anyway.
        function show(next) {
          var prev = i;
          i = next;
          slides[prev].classList.add('is-prev');
          slides[prev].classList.remove('is-current');
          slides[i].classList.add('is-current');
          setTimeout(function () {
            slides[prev].classList.remove('is-prev');
          }, FADE + 50);
        }

        function advance() {
          var next = (i + 1) % slides.length;
          var img = slides[next].querySelector('img');
          if (img && img.decode) {
            img.decode().then(function () { show(next); }, function () { show(next); });
          } else {
            show(next);
          }
        }

        function start() {
          if (timer) return;
          timer = setInterval(advance, interval);
        }
        function stop() {
          if (!timer) return;
          clearInterval(timer);
          timer = null;
        }

        // Only rotate while the band is on screen — no point burning frames
        // (or racing the lazy loader) on a section nobody is looking at.
        if (window.IntersectionObserver) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (e) { e.isIntersecting ? start() : stop(); });
          }, { rootMargin: '100px' }).observe(wrap);
        } else {
          start();
        }
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-related"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    // Resolve the data-intent attribute into an ordered list of intents to
    // try. `complementary-then-related` is the smart default — try the
    // merchant-curated pairings first, fall back to ML-based similar items
    // if no pairings exist for this product yet. Once Aja configures
    // complementary pairs in Shopify Search & Discovery, the cross-sell
    // upgrades automatically without a theme change.
    const intentChain = (intent) => {
      if (intent === 'complementary-then-related') return ['complementary', 'related'];
      if (intent === 'complementary') return ['complementary'];
      return ['related'];
    };

    const fetchRecommendations = (pid, sid, count, intent) => {
      const url = `${root}recommendations/products?section_id=${encodeURIComponent(sid)}&product_id=${encodeURIComponent(pid)}&limit=${count}&intent=${encodeURIComponent(intent)}`;
      return fetch(url, { headers: { 'Accept': 'text/html' } })
        .then((res) => (res.ok ? res.text() : Promise.reject(res.status)))
        .then((html) => {
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const fresh = parsed.querySelector('.pdp-related__grid[data-source="recommendations"]');
          return fresh && fresh.children.length > 0 ? fresh : null;
        });
    };

    // Initialise every PDP related section on the page. Runs at parse time
    // (the script tag is injected after the section markup), so the DOM
    // nodes always exist by the time this fires.
    document.querySelectorAll('.pdp-related[data-product-id]').forEach((section) => {
      // If the section was rendered with a real recommendations grid
      // already (Section Rendering API pass), nothing to do.
      const skel = section.querySelector('.pdp-related__grid--skeleton');
      if (!skel) return;

      const pid = section.dataset.productId;
      const sid = section.dataset.sectionId;
      const count = parseInt(section.dataset.count || '4', 10);
      const intents = intentChain(section.dataset.intent || 'related');
      if (!pid || !sid) { section.style.display = 'none'; return; }

      // Try each intent in order, return the first non-empty grid.
      const tryNext = (i) => {
        if (i >= intents.length) {
          section.style.display = 'none';   // exhausted all intents — hide
          return;
        }
        fetchRecommendations(pid, sid, count, intents[i])
          .then((fresh) => {
            if (fresh) {
              skel.replaceWith(fresh);
            } else {
              tryNext(i + 1);
            }
          })
          .catch(() => tryNext(i + 1));
      };
      tryNext(0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-sticky-cta"]) return;
  try {
    
  (function() {
    const bar = document.querySelector('[data-sticky-cta]');
    const buyCard = document.querySelector('.pdp__buy');
    if (!bar || !buyCard) return;

    const obs = new IntersectionObserver(([entry]) => {
      bar.classList.toggle('is-visible', !entry.isIntersecting);
    }, { rootMargin: '0px 0px -80% 0px' });
    obs.observe(buyCard);

    // Clicking the sticky CTA submits the main PDP form
    bar.querySelector('[data-sticky-add]')?.addEventListener('click', () => {
      const form = document.querySelector('[data-pdp-form]');
      if (!form) return;
      // Use requestSubmit so the submit button's name/value gets serialized
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function() {
    const pdp = document.querySelector('.pdp');
    if (!pdp) return;

    const jsonScript = pdp.querySelector('[data-product-json]');
    if (!jsonScript) return;
    const product = JSON.parse(jsonScript.textContent);
    const form = pdp.querySelector('[data-pdp-form]');
    const variantInput = form?.querySelector('[data-variant-id]');
    const priceEl = pdp.querySelector('[data-price]');
    const compareEl = pdp.querySelector('[data-compare]');
    const ctaEl = pdp.querySelector('[data-cta]');
    const ctaPriceEl = pdp.querySelector('[data-cta-price]');

    // Track selected option values, keyed by position (1-based)
    const selected = {};
    product.options.forEach((name, i) => {
      const variant = product.variants.find(v => v.id === parseInt(variantInput?.value, 10));
      selected[i + 1] = (variant?.options || [])[i] || product.variants[0]?.options[i];
    });

    function formatMoney(cents) {
      // Use the page's existing money formatter when available; otherwise simple $-prefix
      try {
        return (window.Shopify?.formatMoney?.(cents)) || ('$' + (cents / 100).toFixed(2));
      } catch (e) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    function pickValue(optionIndex, value) {
      selected[optionIndex] = value;
      // Find matching variant
      const variant = product.variants.find(v =>
        v.option1 === selected[1] &&
        (product.options.length < 2 || v.option2 === selected[2]) &&
        (product.options.length < 3 || v.option3 === selected[3])
      );
      if (!variant) return;

      variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (ctaPriceEl) ctaPriceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (ctaEl) {
        // Labels come from data attributes, not literals: Liquid never renders
        // inside this block, so this is the only way the swapped label stays in
        // sync with the translation keys — and the only way a "coming soon"
        // product doesn't flip back to "Sold out" on a variant change.
        // is-comingsoon is left alone; it's a product-level state.
        const addLabel = ctaEl.dataset.addLabel || 'Add to cart';
        const unavailableLabel = ctaEl.dataset.unavailableLabel || 'Sold out';
        if (variant.available) {
          ctaEl.classList.remove('is-soldout');
          ctaEl.disabled = false;
          ctaEl.firstChild.textContent = addLabel + ' · ';
        } else {
          if (!ctaEl.classList.contains('is-comingsoon')) ctaEl.classList.add('is-soldout');
          ctaEl.disabled = true;
          ctaEl.firstChild.textContent = unavailableLabel;
          if (ctaPriceEl) ctaPriceEl.textContent = '';
        }
      }
      // Update picked label
      const opt = pdp.querySelector(`[data-option-index="${optionIndex}"] [data-picked]`);
      if (opt) opt.textContent = value;
    }

    // Swatch buttons
    pdp.querySelectorAll('[data-swatches]').forEach(group => {
      const optionIndex = parseInt(group.closest('[data-option-index]')?.dataset.optionIndex, 10);
      group.addEventListener('click', e => {
        const btn = e.target.closest('.pdp__swatch');
        if (!btn) return;
        group.querySelectorAll('.pdp__swatch').forEach(b => {
          b.classList.toggle('on', b === btn);
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        pickValue(optionIndex, btn.dataset.value);
      });
    });

    // Size buttons
    pdp.querySelectorAll('[data-sizes]').forEach(group => {
      const optionIndex = parseInt(group.closest('[data-option-index]')?.dataset.optionIndex, 10);
      group.addEventListener('click', e => {
        const btn = e.target.closest('.pdp__size');
        if (!btn || btn.classList.contains('unavailable')) return;
        group.querySelectorAll('.pdp__size').forEach(b => {
          b.classList.toggle('on', b === btn);
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        pickValue(optionIndex, btn.dataset.value);
      });
    });

    // Other option selects (length, etc.)
    pdp.querySelectorAll('[data-other-option]').forEach(sel => {
      const optionIndex = parseInt(sel.closest('[data-option-index]')?.dataset.optionIndex, 10);
      sel.addEventListener('change', () => pickValue(optionIndex, sel.value));
    });

    // Quantity stepper
    pdp.addEventListener('click', e => {
      const btn = e.target.closest('[data-qty]');
      if (!btn) return;
      const input = btn.closest('.pdp__qty')?.querySelector('input[name="quantity"]');
      if (!input) return;
      const next = Math.max(1, parseInt(input.value, 10) + parseInt(btn.dataset.qty, 10));
      input.value = next;
    });

    // ===== AJAX form submit =====
    // Intercept the PDP Add to Cart form so it adds via /cart/add.js (with the
    // cart-drawer section in the response) and opens the drawer — mirrors the
    // quick-add behavior on product cards. Without this the form does a server
    // POST that redirects to /cart, which is a downgraded UX vs. the live site.
    if (form) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (ctaEl?.disabled) return;

        const formData = new FormData(form);
        const variantId = formData.get('id');
        const quantity = formData.get('quantity') || 1;
        if (!variantId) return;

        const originalLabel = ctaEl?.innerHTML;
        if (ctaEl) {
          ctaEl.disabled = true;
          ctaEl.textContent = 'Adding…';
        }

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              id: variantId,
              quantity: Number(quantity),
              sections: 'cart-drawer'
            })
          });
          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err.description || 'Add failed');
          }
          const data = await res.json();

          // Update header cart count badge — /cart/add.js returns the line
          // item, not the cart total, so we fetch /cart.js for item_count.
          const cart = await fetch('/cart.js').then(r => r.json());
          const cartBtn = document.querySelector('.header__cart-btn');
          if (cartBtn) {
            let badge = cartBtn.querySelector('.header__cart-count');
            if (cart.item_count > 0) {
              if (!badge) {
                badge = document.createElement('span');
                badge.className = 'header__cart-count';
                cartBtn.appendChild(badge);
              }
              badge.textContent = cart.item_count;
            } else if (badge) {
              badge.remove();
            }
          }

          // Swap the drawer's contents with the freshly-rendered HTML
          if (data.sections && data.sections['cart-drawer']) {
            const parser = new DOMParser();
            const newDrawerDoc = parser.parseFromString(data.sections['cart-drawer'], 'text/html');
            const freshDrawer = newDrawerDoc.querySelector('#cart-drawer');
            const existingDrawer = document.querySelector('#cart-drawer');
            if (freshDrawer && existingDrawer) {
              existingDrawer.innerHTML = freshDrawer.innerHTML;
            }
          }

          // Brief success state on the button, then open the drawer
          if (ctaEl) {
            ctaEl.textContent = 'Added ✓';
            setTimeout(() => {
              // Use the drawer-controls openDrawer mechanism — fire a synthetic
              // click on an element with data-open-drawer. The existing global
              // delegated handler in snippets/drawer-controls.liquid catches it.
              const opener = document.createElement('button');
              opener.setAttribute('data-open-drawer', 'cart-drawer');
              opener.style.display = 'none';
              document.body.appendChild(opener);
              opener.click();
              opener.remove();

              ctaEl.innerHTML = originalLabel;
              ctaEl.disabled = false;
            }, 350);
          }
        } catch (err) {
          if (ctaEl) {
            ctaEl.textContent = 'Try again';
            setTimeout(() => {
              ctaEl.innerHTML = originalLabel;
              ctaEl.disabled = false;
            }, 1800);
          }
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reels-feed"] && !Shopify.designMode) return;
  try {
    
  // Reel iframes are mounted on demand, not up front.
  //
  // Each instagram.com/…/embed/ iframe is a whole third-party document with
  // its own renderer and <video>. `loading="lazy"` doesn't bound that: the
  // tiles sit side by side in one horizontal row, so the moment the row
  // scrolls into view every tile is "near the viewport" and all of them load
  // and then stay loaded for the rest of the session. Twelve of those at once
  // is enough GPU/memory pressure that the compositor starts dropping tiles
  // for the page's biggest photo layers — the hero and the lifestyle band
  // paint EMPTY, showing just their pink background plus scrim, and any
  // repaint (moving the mouse over them is enough) makes it visible. That's
  // the bug this guards against, so keep the teardown AND the MAX_LIVE cap.
  //
  // Within that guard, mount as EARLY as possible: an embed takes ~1-4s to
  // boot, so any tile that only starts mounting when it becomes visible is
  // watched as a blank placeholder for those seconds.
  //
  // Gate 1 (vertical): mounting starts once the row is within ~2 screens of
  // the viewport, so embeds boot while the visitor is still reading the
  // sections above; everything unmounts once the row is well past.
  // Gate 2 (horizontal): visible tiles mount first, then neighbours by
  // distance (ahead of the next arrow favoured) out to one full page each
  // side, stopping at a hard cap of live embeds — 8 on desktop, 5 on phones,
  // both safely under the 12 that triggered the compositor bug.
  document.querySelectorAll('[data-reels-row]').forEach(function (row) {
    var frames = Array.prototype.slice.call(row.querySelectorAll('iframe[data-src]'));
    if (!frames.length) return;

    function mount(frame) {
      if (frame.dataset.mounted === '1') return;
      frame.dataset.mounted = '1';
      // The markup's loading="lazy" is for the no-IntersectionObserver path
      // below, where every tile mounts at once. Here WE are the scheduler,
      // and tiles are deliberately mounted while still far offscreen — go
      // eager so the browser doesn't re-defer the fetch until "near viewport".
      frame.setAttribute('loading', 'eager');
      frame.src = frame.dataset.src;
    }
    // about:blank rather than removeAttribute — removing the attribute leaves
    // the existing document (and its video) alive; navigating away frees it.
    function unmount(frame) {
      if (frame.dataset.mounted !== '1') return;
      frame.dataset.mounted = '';
      frame.src = 'about:blank';
    }

    if (!window.IntersectionObserver) {
      frames.forEach(mount);
      return;
    }

    var rowNear = false;
    var queued = false;

    function refresh() {
      queued = false;
      if (!rowNear) {
        frames.forEach(unmount);
        return;
      }
      var maxLive = window.innerWidth < 720 ? 5 : 8;
      var bounds = row.getBoundingClientRect();
      var first = -1;
      var last = -1;
      frames.forEach(function (frame, index) {
        var box = frame.getBoundingClientRect();
        if (box.right > bounds.left && box.left < bounds.right) {
          if (first < 0) first = index;
          last = index;
        }
      });
      if (first < 0) { first = 0; last = 0; }
      // Keep-list by priority: what's in the row's window, then neighbours by
      // distance — ahead of the next arrow first, since that's the dominant
      // gesture — out to one full page per side. An arrow click advances by
      // one page, so the landing tiles are already warm when the snap settles.
      var pageSize = last - first + 1;
      var keep = {};
      var kept = 0;
      var index;
      for (index = first; index <= last && kept < maxLive; index++) {
        keep[index] = 1;
        kept++;
      }
      for (var offset = 1; offset <= pageSize && kept < maxLive; offset++) {
        index = last + offset;
        if (index < frames.length) { keep[index] = 1; kept++; }
        index = first - offset;
        if (index >= 0 && kept < maxLive) { keep[index] = 1; kept++; }
      }
      frames.forEach(function (frame, i) {
        if (keep[i]) mount(frame);
        else unmount(frame);
      });
    }

    function schedule() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(refresh);
    }

    // ~2 screens of pre-roll: at reading-speed scroll that's several seconds
    // of boot time before the row arrives, and a visitor bouncing between the
    // row and nearby sections never churns their embeds.
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { rowNear = entry.isIntersecting; });
      schedule();
    }, { rootMargin: '1800px 0px' }).observe(row);

    row.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    schedule();
  });

  // Reels carousel — arrows drive the native scroll-snap row rather than
  // replacing it, so touch swipe, trackpad and keyboard all keep working and
  // the row still renders fine with JS off (arrows stay hidden until we
  // confirm there's actually something to scroll).
  document.querySelectorAll('[data-reels-carousel]').forEach(function (root) {
    var row = root.querySelector('[data-reels-row]');
    var prev = root.querySelector('[data-reels-prev]');
    var next = root.querySelector('[data-reels-next]');
    if (!row || !prev || !next) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Advance by whole tiles so the scroll-snap always lands cleanly.
    function stepSize() {
      var tile = row.querySelector('.reels__tile');
      if (!tile) return row.clientWidth;
      var gap = parseInt(window.getComputedStyle(row).columnGap, 10) || 0;
      var unit = tile.offsetWidth + gap;
      var perPage = Math.max(1, Math.floor(row.clientWidth / unit));
      return unit * perPage;
    }

    // Measure against the tiles, not scrollWidth: the row's gutter padding
    // inflates scrollWidth even when nothing is scrollable, and scroll-snap
    // caps the reachable scrollLeft below (scrollWidth - clientWidth), which
    // would otherwise leave the next arrow lit but dead at the end.
    function edges() {
      var tiles = row.querySelectorAll('.reels__tile');
      var last = tiles[tiles.length - 1];
      if (!last) return { atStart: true, atEnd: true };
      var rowRect = row.getBoundingClientRect();
      return {
        atStart: row.scrollLeft <= 1,
        atEnd: last.getBoundingClientRect().right <= rowRect.right + 2
      };
    }

    function sync() {
      var edge = edges();
      root.classList.toggle('is-scrollable', !(edge.atStart && edge.atEnd));
      prev.disabled = edge.atStart;
      next.disabled = edge.atEnd;
    }

    function move(direction) {
      var max = row.scrollWidth - row.clientWidth;
      var target = Math.max(0, Math.min(max, row.scrollLeft + direction * stepSize()));
      row.scrollTo({ left: target, behavior: reduce ? 'auto' : 'smooth' });
    }

    prev.addEventListener('click', function () { move(-1); });
    next.addEventListener('click', function () { move(1); });
    row.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);

    sync();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-highlights"] && !Shopify.designMode) return;
  try {
    
  // Review carousel — one card at a time, auto-advancing, pause on hover/focus.
  document.querySelectorAll('[data-rev-carousel]').forEach(function (root) {
    var track = root.querySelector('[data-rev-track]');
    var slides = root.querySelectorAll('[data-rev-slide]');
    var dots = root.querySelectorAll('[data-rev-dot]');
    var prev = root.querySelector('[data-rev-prev]');
    var next = root.querySelector('[data-rev-next]');
    if (!track || slides.length < 2) return;

    var i = 0;
    var timer = null;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = root.getAttribute('data-rev-autoplay') === 'true' && !reduce;
    var interval = parseInt(root.getAttribute('data-rev-interval'), 10) || 6000;

    function go(n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (-i * 100) + '%)';
      dots.forEach(function (d, di) {
        d.classList.toggle('is-active', di === i);
        d.setAttribute('aria-current', di === i ? 'true' : 'false');
      });
    }
    function start() { if (!autoplay) return; stop(); timer = setInterval(function () { go(i + 1); }, interval); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    if (prev) prev.addEventListener('click', function () { go(i - 1); start(); });
    if (next) next.addEventListener('click', function () { go(i + 1); start(); });
    dots.forEach(function (d, di) { d.addEventListener('click', function () { go(di); start(); }); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    go(0);
    start();
  });

  } catch(e) { console.error(e); }
})();
})();
